import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { Storage } from '@ionic/storage';

import { LoadingPage } from '../loading/loading';
import { HomePage } from '../home/home';

import { DataProvider } from '../../providers/data/data';
import { ConstantsProvider } from '../../providers/constants/constants';
import { CloudDataProvider } from '../../providers/cloud-data/cloud-data';


import * as $ from 'jquery';
import { Console } from '@angular/core/src/console';

@Component({

   selector: 'page-login',
   templateUrl: 'login.html'
})

export class LoginPage
{

   // to hold user input
   private username: any = '';
   private password: any = '';
   private loginMode = 0;


   /** ----- Constructor ----- **/

   constructor( private data: DataProvider,
                private constants: ConstantsProvider,
                private cloudData: CloudDataProvider,
                private navCtrl: NavController,
                private modalCtrl: ModalController,
                private alertCtrl: AlertController,
                private storage: Storage )
   {}


   /** ----- View LifeCycle ----- **/

   ionViewWillEnter()
   {

      $( '#login-logo' ).height( $( '#login-logo' ).width() * 0.9434 );

   }


   /** ----- UI Callbacks ----- **/

   onLoginClicked()
   {
      // this.constants.isAdmin = this.loginMode == 0 ? true : false;
      // if username and password is valid
      if ( this.username.length > 0 && this.password.length > 0 )
      {
         // pack input values
         let params = {
            'username' : this.username,
            'password' : this.password
         };

         // show loading indicator and try to login
         let loading = this.modalCtrl.create( LoadingPage, {}, { enableBackdropDismiss: false } );
         loading.present();
         this.cloudData.login( this.loginMode, params ).then( res => {

            // handle response
            if ( res[ 'status' ] == true )
            {
               this.storage.set( 'chains-token', res[ 'result' ] ).then( token => {

                  // save token
                  this.data.isPhy = ( this.loginMode == 0 ) ? true : false;
                  this.data.token = token;

                  this.cloudData.getSelf( this.loginMode ).then( res => {

                     // dismiss loading indicator and handle response
                     loading.dismiss();
                     if ( res[ 'status' ] == true )
                     {

                        // save account info, clear input values and push to HomePage
                        this.data.accountInfo = res[ 'result' ];
                        this.username = '';
                        this.password = '';
                        this.navCtrl.push( HomePage );

                     }
                     else
                     {
                        // dismiss loading and show error message
                        this.showAlert( '登入失敗', '使用者名稱／密碼錯誤', '確認' );
                     }
                  });
               });
            }
            else
            {
               // dismiss loading and show error message
               loading.dismiss();
               this.showAlert( '登入失敗', '使用者名稱／密碼錯誤', '確認' );
            }
         });
      }
      else
      {
         // show error message
         this.showAlert( '登入失敗', '請輸入有效的使用者名稱及密碼', '確認' );
      }

   }


   onLoginModeClicked( inIdx )
   {

      this.loginMode = inIdx;

   }


   /** ----- Internal Methods ----- **/

   showAlert( inTitle, inMsg, inConfirm )
   {

      let alert = this.alertCtrl.create({
         title    : inTitle,
         subTitle : inMsg,
         buttons  : [ inConfirm ],
         enableBackdropDismiss: false
      });
      alert.present();

   }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts